import React from "react";
import "./Logos.css";
import ADVANCELogo from "./images/logos/ADVANCE.svg";
import IEEELogo from "./images/logos/IEEE.jpg";
import UCCLlogo from "./images/logos/UCC.png";
import MTULogo from "./images/logos/MTU.jpg";
import MSTLogo from "./images/logos/Missouri.jpg";
import IBM from "./images/logos/ibm.png";
import Horner from "./images/logos/horner.png";

const Logos = () => {
  const logos = [
    {
      name: "IEEE",
      logo: IEEELogo,
      url: "https://www.ieee.org/",
    },
    {
      name: "ADVANCE CRT",
      logo: ADVANCELogo,
      url: "https://www.advance-crt.ie/",
    },
    {
      name: "UCC",
      logo: UCCLlogo,
      url: "https://www.ucc.ie/",
    },
    {
      name: "MTU",
      logo: MTULogo,
      url: "https://www.mtu.ie/",
    },
    {
      name: "MST",
      logo: MSTLogo,
      url: "https://www.mst.edu/",
    },
  ];

  const patrons = [
    {
      name: "IBM",
      logo: IBM,
      url: "https://www.ibm.com/us-en",
    },
    {
      name: "Horner Automation",
      logo: Horner,
      url: "https://hornerautomation.eu/",
    },
  ];

  return (
    <div className="logo-container">
      {logos.map(function (data) {
        {
          console.log(data.logo);
        }

        return (
          <a href={data.url}>
            <img className="logo-image" src={data.logo} />
          </a>
        );
      })}
    </div>
  );
};

export default Logos;
